const ACCOMMODATION = 'accommodation';
const INSTALLATION = 'installation';
const LIFTERS = 'lifters';

export { ACCOMMODATION, INSTALLATION, LIFTERS };
